import React from 'react';

const IconChevronDown: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="6"
      {...props}
    >
      <polyline
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        points="0.5,0.5 5.5,5.5 10.5,0.5"
      ></polyline>
    </svg>
  );
};

export default IconChevronDown;
